
$(function () {
  /*==================================================
footer追従 footer超えたらfadeIn
==================================================*/
  // 企業詳細でtab-contentが読み込まれた後にfooterの高さ取得
  if ($('.search-result-box, .footer-fixed-box, .footer-submit').length && $('.message-mail-fixed').length == 0) {
    setTimeout(function () {
      var scrollEnd = $('.footer').offset().top;
      var distance = 0;

      $(document).scroll(function () {
        distance = $(this).scrollTop(); //スクロールした距離を取得
        if (scrollEnd - 500 < distance) { //スクロール距離が『.contact』の位置を超えたら
          $('.footer-fixed-box, .footer-submit').addClass('none'); //class『none』を追加
        } else {
          $('.footer-fixed-box, .footer-submit').removeClass('none'); //class『none』を削除
        }
      });
    }, 3000);//ページ上部からの距離を取得

    setTimeout(function () {
      var scrollEnd = $('.footer').offset().top;
      var distance = 0;

      $(window).on('scroll resize',function () {
        distance = $(this).scrollTop(); //スクロールした距離を取得
        var winW = $(window).width();
        if (winW <= 991) {
          if (scrollEnd - 500 < distance) { //スクロール距離が『.contact』の位置を超えたら
            $('.js-tab-list').addClass('none'); //class『none』を追加
          } else {
            $('.js-tab-list').removeClass('none'); //class『none』を削除
          }
        }else {
          $('.js-tab-list').removeClass('none');
        }
      });
    }, 3000);//ページ上部からの距離を取得

  }else if ($('.message-mail-fixed').length){
// ページの高さが短い時
    setTimeout(function () {
      var scrollEnd = $('.footer').offset().top;
      var distance = 0;

      $(document).scroll(function () {
        distance = $(this).scrollTop(); //スクロールした距離を取得
        if (scrollEnd - 300 < distance) { //スクロール距離が『.contact』の位置を超えたら
          $('.footer-fixed-box, .footer-submit').addClass('none'); //class『none』を追加
        } else {
          $('.footer-fixed-box, .footer-submit').removeClass('none'); //class『none』を削除
        }
      });
    }, 3000);//ページ上部からの距離を取得

    setTimeout(function () {
      var scrollEnd = $('.footer').offset().top;
      var distance = 0;

      $(window).on('scroll resize',function () {
        distance = $(this).scrollTop(); //スクロールした距離を取得
        var winW = $(window).width();
        if (winW <= 991) {
          if (scrollEnd - 500 < distance) { //スクロール距離が『.contact』の位置を超えたら
            $('.js-tab-list').addClass('none'); //class『none』を追加
          } else {
            $('.js-tab-list').removeClass('none'); //class『none』を削除
          }
        }else {
          $('.js-tab-list').removeClass('none');
        }
      });
    }, 3000);//ページ上部からの距離を取得
  }
});
